export default __webpack_public_path__ + "static/media/logo.e1665647.webp";